import { FaInstagram } from "react-icons/fa";

export default function InstagramIcon({ size }) {
    return <FaInstagram size={size} />;
}